import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'
import Select from 'react-select'

import EditUser from '../../components/modals/edituser'
import NewUser from '../../components/modals/newuser'
import Receive from '../../components/reusable/receive'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

const Users = () => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')
    const [role, setRole] = useState()

    const [newUserModal, toggleNewUserModal] = useToggle()
    const [userModal, toggleUserModal] = useToggle()

    const select = usr => {
        setSelected(usr)
        toggleUserModal()
    }
    
    const [
        { loading: rLoading, error: rError, fetch: rFetch }, 
        { list: roles }, 
    ] = useListData('roles', { string, limit: 100 }, { notify: true, manual: false })
    
    const [
        { loading, error, fetch }, 
        { list: users }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('allUsers', role ? { string, role: role?.value } : { string } , { notify: true, manual: false }, 'users')

    const search = str => {
        setString(str)
        navigate(1)
        fetch()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Account has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        fetch()
    }

    const [, execute] = usePet('toggleActive', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = usr => {
        setSelected(usr)
        execute()        
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newUserModal &&
                <NewUser
                    onPerform={ fetch }
                    toggle={ toggleNewUserModal }
                    visible={ newUserModal } />
            }
            
            {
                userModal &&
                <EditUser
                    onPerform={ fetch }
                    user={ selected }
                    toggle={ toggleUserModal }
                    visible={ userModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewUserModal } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Add New User</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Users</h2>
                    <Receive
                        error={ rError }
                        loading={ rLoading }
                        progress>
                        <Select
                            isClearable
                            value={ role }
                            onChange={ setRole }
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={roles?.map(role => ({ label: role.name, value: role._id }))}
                            placeholder="Select Role" />
                    </Receive>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                users.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                users.map((user, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ user.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ `text-center ${ user.active ? 'text-green-500' : 'text-gray-700' }` }>{ user.active ? 'Active' : 'Inactive' }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(user.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(user) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(user) }>{ user.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new user</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Users
